import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

export const usuariosSlice = createSlice({
    name: "usuarios",
    initialState: {
        listaUsuarios: [],
        ciudad:[],
        single_user:{},
        isLoading: false
    },
    reducers: {
        setUsers: (state, action) => {
            //console.log("setAccion", action.payload);
            state.listaUsuarios = action.payload;
        },
        setCiudades:(state,action)=>{
            state.ciudad=action.payload;
        },
        setSingleUser:(state,action)=>{
            state.single_user=action.payload;
        }
    }
});

export const AddUser = (Usuario, token) => async (dispatch) => {
    //console.log("usuarioDispach", token)
    const res = await axios.post('https://api.ticc.com.mx/api/AddUser', null, {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        Accept: "*/*",
        "Access-Control-Allow-Origin": "*",
        params: Usuario
    });
    //console.log("Add_respuesta", res);
    dispatch(GetUsers(token));
};


export const GetUsers = (token) => async (dispatch) => {
    //console.log('sendToken',token);
    const res = await axios.get('https://api.ticc.com.mx/api/users', {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
        "Accept": "*/*",
        "Access-Control-Allow-Origin":"*",
    });
    dispatch(setUsers(res.data.users));
};


//Obtner el estado global
export const selectStateUsers = (state) => state.usuarios.listaUsuarios;
export const selectCiudades = (state) => state.usuarios.ciudad;
export const selectSingleUser=(state)=>state.usuarios.single_user;

//Export otras acciones
export const { setUsers,setCiudades,setSingleUser } = usuariosSlice.actions;
//Reducer
export default usuariosSlice.reducer;